import { FC, ReactNode } from "react";

import { DefinitionRowStyled } from "../investigation.panel.styled";

/** A label/value definition row used in the investigation summary sections. */
export const InvestigationDefinitionRow: FC<{
  label: string;
  value: ReactNode;
}> = ({ label, value }) => (
  <DefinitionRowStyled>
    <span className="def-label">{label}</span>
    <span className="def-value">{value}</span>
  </DefinitionRowStyled>
);
